var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./MasterServiceQuestionDetail.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-1b985b78!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!../../node_modules/vue-loader/lib/selector?type=template&index=0!./MasterServiceQuestionDetail.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MasterServiceQuestionDetail.vue
// module id = 653
// module chunks = 1